// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"354":"d6139d17","488":"6d7e9a16","672":"28f5b817"}[chunkId] + ".chunk.js";
};